<div class="sheet-wrapper" rtlDiv>
    <div class="drag-handle"></div>
  
    <div class="sheet-header" rtlDiv>
      <span class="sheet-title">{{ 'OTHER.FILTERS' | translate }}</span>
      <span class="clear-all-link" (click)="clearAll()">{{ 'LIVE_INFO.CLEAR_ALL' | translate }}</span>
    </div>
  
    <div class="sheet-body">
  
      @if(page == 'inventory') {
  
        <!-- Sites -->
        @if(sitesList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'NEW_WORKPLAN.SITES' | translate }}</span>
                @if(getSelectedCount(sitesList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(sitesList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="siteSearch" (ngModelChange)="onSiteSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (site of displaySitesList; track site.site) {
                <div class="option-item" (click)="toggleItem(sitesList, site, 'site')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="site.selected">
                    @if(site.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ site.site }}</span>
                    <span class="option-count">({{ site.num_of_bins_in_site }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
  
        <!-- Types -->
        @if(typesList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'LIST_COLUMNS.BIN_TYPE' | translate }}</span>
                @if(getSelectedCount(typesList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(typesList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="typeSearch" (ngModelChange)="onTypeSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (type of displayTypesList; track type.type) {
                <div class="option-item" (click)="toggleItem(typesList, type, 'type')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="type.selected">
                    @if(type.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ type.type }}</span>
                    <span class="option-count">({{ type.num_of_bins_in_type }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
  
        <!-- Neighborhoods -->
        @if(neighborhoodsList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'LIST_COLUMNS.NEIGHBORHOOD' | translate }}</span>
                @if(getSelectedCount(neighborhoodsList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(neighborhoodsList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="neighborhoodSearch" (ngModelChange)="onNeighborhoodSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (neighborhood of displayNeighborhoodsList; track neighborhood.neighborhood) {
                <div class="option-item" (click)="toggleItem(neighborhoodsList, neighborhood, 'neighborhood')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="neighborhood.selected">
                    @if(neighborhood.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ neighborhood.neighborhood }}</span>
                    <span class="option-count">({{ neighborhood.num_of_bins_in_nbrh }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
  
        <!-- Collection Mode -->
        @if(collectionModeList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'MANAGE_BIN.INCLUDE_IN_WORKPLAN' | translate }}</span>
                @if(getSelectedCount(collectionModeList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(collectionModeList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="collectionModeSearch" (ngModelChange)="onCollectionModeSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (cm of displayCollectionModeList; track cm.id) {
                <div class="option-item" (click)="toggleItem(collectionModeList, cm, 'id')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="cm.selected">
                    @if(cm.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ cm.name }}</span>
                    <span class="option-count">({{ cm.num_of_bins_in_collection_mode }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      }
  
      @else if(page == 'ticketManagement' || page == 'technicianTicketManagement') {
  
        <!-- Ticket Type (technicianTicketManagement only) -->
        @if(page == 'technicianTicketManagement' && ticketTypeList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'TICKET_MANAGEMENT.EVENT_TYPE' | translate }}</span>
                @if(getSelectedCount(ticketTypeList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(ticketTypeList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="ticketTypeSearch" (ngModelChange)="onTicketTypeSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (tt of displayTicketTypeList; track tt.ticket_type) {
                <div class="option-item" (click)="toggleItem(ticketTypeList, tt, 'ticket_type')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="tt.selected">
                    @if(tt.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ currentLang == 'iw' ? tt.ticket_type_hebrew : tt.ticket_type }}</span>
                    <span class="option-count">({{ tt.num_of_tickets_in_ticket_type }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
  
        <!-- Event Cause -->
        @if(eventCauseList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'TICKET_MANAGEMENT.EVENT_CAUSE' | translate }}</span>
                @if(getSelectedCount(eventCauseList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(eventCauseList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="eventCauseSearch" (ngModelChange)="onEventCauseSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (ec of displayEventCauseList; track ec.eventCauseEn) {
                <div class="option-item" (click)="toggleItem(eventCauseList, ec, 'eventCauseEn')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="ec.selected">
                    @if(ec.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ currentLang == 'iw' ? ec.eventCauseHe : ec.eventCauseEn }}</span>
                    <span class="option-count">({{ ec.num_of_bins_in_event_cause }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
  
        @if(statusList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'TICKET_MANAGEMENT.STATUS' | translate }}</span>
                @if(getSelectedCount(statusList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(statusList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="statusSearch" (ngModelChange)="onStatusSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (st of displayStatusList; track st.status) {
                <div class="option-item" (click)="toggleItem(statusList, st, 'status')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="st.selected">
                    @if(st.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ st.status_txt }}</span>
                    <span class="option-count">({{ st.num_of_tickets_in_status }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      }
      @else if(page == 'workplanTruckList') {

        <!-- Exceptions -->
        @if(exceptionsList.length > 0) {
          <mat-expansion-panel class="filter-section" hideToggle>
            <mat-expansion-panel-header class="filter-section-header">
              <mat-panel-title class="filter-section-title" rtlDiv>
                <span>{{ 'LIST_COLUMNS.EXCEPTIONS' | translate }}</span>
                @if(getSelectedCount(exceptionsList) > 0) {
                  <span class="filter-badge">{{ getSelectedCount(exceptionsList) }}</span>
                }
              </mat-panel-title>
              <mat-panel-description class="filter-chevron">
                <img class="chevron-icon" src="assets/images/dashboard/chevron.svg" alt="">
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="search-input-container" rtlDiv>
              <img class="search-input-img" src="assets/images/sidemenu/table_search_icon.png" alt="">
              <input class="filter-input" [(ngModel)]="exceptionSearch" (ngModelChange)="onExceptionSearch($event)" placeholder="{{ 'OTHER.SEARCH' | translate }}" type="text">
            </div>
            <div class="options-list">
              @for (exception of displayExceptionsList; track exception.key) {
                <div class="option-item" (click)="toggleItem(exceptionsList, exception, 'key')" rtlDiv>
                  <div class="checkbox-custom" [class.checked]="exception.selected">
                    @if(exception.selected) { <span class="checkmark">✓</span> }
                  </div>
                  <div class="option-label" rtlDiv>
                    <span>{{ exception.name }}</span>
                    <span class="option-count">({{ exception.num_of_bins_in_exception }})</span>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      }
  
    </div>
  
    <div class="sheet-footer" rtlDiv>
      <button class="apply-btn" (click)="apply()">
        {{ 'TITLES.APPLY' | translate }}
        @if(totalActiveFilters > 0) {
          <span class="apply-badge">{{ totalActiveFilters }}</span>
        }
      </button>
    </div>
  </div>
  